export enum PurchaseTypeEnum {
  STORE = 'STORE',
  INTERNET = 'INTERNET'
}
